import React from "react";

export const EMPTY_FILTERS = { employeeId: "", status: "", startDate: "", endDate: "" };

const LeaveFilters = ({ filters, onChange, employees }) => {
  const set = (key, value) => onChange({ ...filters, [key]: value });
  return (
    <div className="flex gap-4 mb-6 bg-gray-50 p-4 rounded-lg border">
      <div className="flex-1">
        <label className="block text-sm font-medium mb-1">Employee</label>
        <select
          className="w-full border p-2 rounded bg-white"
          value={filters.employeeId}
          onChange={(e) => set("employeeId", e.target.value)}
        >
          <option value="">All Employees</option>
          {employees.map((emp) => (
            <option key={emp.id} value={emp.id}>
              {emp.fullName}
            </option>
          ))}
        </select>
      </div>
      <div className="flex-1">
        <label className="block text-sm font-medium mb-1">Status</label>
        <select
          className="w-full border p-2 rounded bg-white"
          value={filters.status}
          onChange={(e) => set("status", e.target.value)}
        >
          <option value="">All Statuses</option>
          <option value="PENDING">Pending</option>
          <option value="APPROVED">Approved</option>
          <option value="REJECTED">Rejected</option>
          <option value="ABSENT">Absent</option>
          <option value="CANCELLED">Cancelled</option>
        </select>
      </div>
      <div className="flex-1">
        <label className="block text-sm font-medium mb-1">Start Date</label>
        <input
          type="date"
          className="w-full border p-2 rounded bg-white"
          value={filters.startDate}
          onChange={(e) => set("startDate", e.target.value)}
        />
      </div>
      <div className="flex-1">
        <label className="block text-sm font-medium mb-1">End Date</label>
        <input
          type="date"
          className="w-full border p-2 rounded bg-white"
          value={filters.endDate}
          onChange={(e) => set("endDate", e.target.value)}
        />
      </div>
      <div className="flex items-end">
        <button
          onClick={() => onChange(EMPTY_FILTERS)}
          className="px-4 py-2 border rounded bg-white hover:bg-gray-100 transition"
        >
          Clear Filters
        </button>
      </div>
    </div>
  );
};

export default LeaveFilters;
